
class PopupManager {
  private listener: ((popup: boolean) => void) | undefined

  show() {
    this.listener?.(true)
  }

  hide() {
    this.listener?.(false)
  }

  subscribe(fn: (showPopup: boolean) => void) {
    this.listener = fn
  }

  unsubscribe() {
    this.listener = undefined
  }
}

const popupManager = new PopupManager()
export default popupManager
